import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import AuthApp from './AuthApp';
import theme from './theme';

// Import Google font
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap';
document.head.appendChild(link);

// Create a style element for global styles
const style = document.createElement('style');
style.innerHTML = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Inter', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    overflow-y: auto;
    min-height: 100vh;
    width: 100%;
  }
`;

document.head.appendChild(style);

// Find or create the root element
let rootElement = document.getElementById('root');
if (!rootElement) {
  // Create root element if it doesn't exist
  rootElement = document.createElement('div');
  rootElement.id = 'root';
  document.body.appendChild(rootElement);
}

// Create root
const root = ReactDOM.createRoot(rootElement);

// Application with providers and routing
const AppWithProviders = () => {
  // Check if we're on public routes (accessible without authentication)
  // Public routes: /s/:code - shared chart view (read-only mode)
  const isPublicRoute = window.location.pathname.startsWith('/s/');

  // Check if we're on auth-only routes (login/register)
  const isAuthOnlyRoute = window.location.pathname.startsWith('/login') ||
                          window.location.pathname.startsWith('/register') ||
                          window.location.pathname.startsWith('/auth/callback');

  // Auth routing is handled by AuthContext in App and AuthApp
  // No localStorage check - we use httpOnly cookies
  return (
    <ChakraProvider theme={theme}>
      {isAuthOnlyRoute ? <AuthApp /> : <App />}
    </ChakraProvider>
  );
};

// Always render with StrictMode (TEMPORARILY DISABLED FOR DEBUGGING)
root.render(
  <AppWithProviders />
);
